import { AppThunk } from '../../../store/rootReducer';
import * as ruler2dActions from '../actions/ruler2d.actions';
import { isUpdatingRuler2dSelector } from '../selectors/ruler2d.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';

export const stopRuler2d = (): AppThunk => async (dispatch, getState) => {
  const isUpdatingRuler2d = isUpdatingRuler2dSelector(getState());
  const isRulerActive = isToolActiveSelector(Tool.ruler2d)(getState());

  if (isUpdatingRuler2d && isRulerActive) {
    dispatch(ruler2dActions.stop());
  }
};
